(() => {
  if (window.AirtangCartDrawerRecommendationsInitialized) return;
  window.AirtangCartDrawerRecommendationsInitialized = true;

  const FORM_SELECTOR = 'form[data-cart-drawer-rec-form]';
  const CART_ICON_BUBBLE_SELECTOR = '#cart-icon-bubble';
  const CART_ICON_SECTION_ID = 'cart-icon-bubble';

  const renderSectionInnerHTML = (html, selector = '.shopify-section') => {
    if (!html) return '';
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const node = parsed.querySelector(selector);
    return node ? node.innerHTML : '';
  };

  const updateCartIconBubble = async (parsedState) => {
    const cartIconBubble = document.querySelector(CART_ICON_BUBBLE_SELECTOR);
    if (!cartIconBubble) return;

    const sectionMarkup = parsedState?.sections?.[CART_ICON_SECTION_ID];
    if (sectionMarkup) {
      const innerHTML = renderSectionInnerHTML(sectionMarkup);
      if (innerHTML) cartIconBubble.innerHTML = innerHTML;
      return;
    }

    try {
      const response = await fetch(`${window.routes.cart_url}?section_id=${CART_ICON_SECTION_ID}`);
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector('.shopify-section');
      if (source) cartIconBubble.innerHTML = source.innerHTML;
    } catch (error) {
      console.error(error);
    }
  };

  const refreshDrawerItems = async () => {
    const drawerItems = document.querySelector('cart-drawer-items');
    if (!drawerItems || typeof drawerItems.onCartUpdate !== 'function') return;

    await drawerItems.onCartUpdate();
  };

  const onSubmit = async (event) => {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();

    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');

    const formData = new FormData(form);
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(submitButton);
    }

    try {
      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(window.routes.cart_add_url, config);
      const parsedState = await response.json();

      if (!response.ok || parsedState.status) return;

      if (cartDrawer) {
        if (parsedState.sections) {
          cartDrawer.renderContents(parsedState);
          await refreshDrawerItems();
        } else {
          await refreshDrawerItems();
          await updateCartIconBubble(parsedState);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        }
      } else {
        window.location = window.routes.cart_url;
      }

    } catch (error) {
      console.error(error);
    } finally {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
    }
  };

  document.addEventListener('submit', onSubmit);
})();
